import {ChangeDetectionStrategy, Component, input} from '@angular/core'
import {IconProp} from '@fortawesome/fontawesome-svg-core'
import {faPen} from '@fortawesome/pro-regular-svg-icons/faPen'

@Component({
  selector: 'bgo-job-request-fragment-summary-card',
  templateUrl: './job-request-fragment-summary-card.component.html',
  styles: [':host { display: block; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobRequestFragmentSummaryCardComponent {
  icon = input.required<IconProp>()
  editPath = input.required<string>()
  fragment = input<string>()

  readonly editIcon = faPen
}
